import { call, put, takeLatest } from 'redux-saga/effects';
import Api from '../api';
import _ from 'lodash';


function* fetchDoc( action )
{
    try
    {
        const opts = action.opts;

        const pkg = yield call(
            Api.fetchDoc,
            action.packageName,
            _.get( opts, 'type', null ),
            _.get( opts, 'channel', null ),
            _.get( opts, 'signature', null )
        );

        yield put( { type: 'DOC_FETCH_SUCCEEDED', pkg : pkg } );
    }
    catch( e )
    {
        console.error( e );
        yield put( { type: 'DOC_FETCH_FAILED', message: e.message } );
    }
}


function* mySaga()
{
    yield takeLatest( 'DOC_FETCH_REQUESTED', fetchDoc );
}

export default mySaga;




// WEBPACK FOOTER //
// ./src/lib/sagas/fetch-doc.js